import { useNavigate } from "react-router";
import { useTestStore } from "../../../hooks/store";
import { useEffect } from "react";
import { testType } from "../../../utils/testHelper";

export function Marathon() {
  const testStore = useTestStore();
  const nav = useNavigate();

  const navToSolve = () => {
    // testStore.resetTest();
    nav(`../test?testType=${testType.marathon.type}`);
    testStore.setBaseData(testType.marathon, "Марафон ПДД ПМР", 0);
  };

  useEffect(navToSolve, []);
  return;
}
